import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography } from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert";

const ManagerStudentPart2 = ({open, onClose, reload}) =>  {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const [file, set_file] = React.useState(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {alert, renderAlert} = useAlert()
  const onChangeFile = (e) => {
    const file = e.target.files[0]
    set_file(file)
  }

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      set_file(null)
      onClose()
    }
  }

  const onUpload = async() => {
    const url = `/student/upload/${schola.id}`
    const formData = new FormData()

    if(file != null) {
      // formData.append(`files`, file)
      const f = new File([file], file.name, { type: file.type }) 
      formData.append(`files`, f)

      openIndicator()
      const resp = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      closeIndicator()

      if (resp.data.repCode !== 'ack') {
        alert(resp.data.repMessage)
        return

      } else {set_file(null)

        reload()
        alert('저장되었습니다.', handleClose)
      }
    }

  }

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name} 
          </Typography>
        
          <Typography variant='body' align='center'>학생 파일 업로드</Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <Typography variant='body2' color={theme.palette.secondary.dark}>
            - 해당 학교의 전체 학생목록을 업로드해야 합니다.<br/> 
            - 만일 서버에는 학생정보가 있으나 업로드할 파일에는 존재하지 않을 경우 그 학생은 조회되지 않게 됩니다.<br/>
            - 학년이 바뀌어 기존 6학년 데이터는 지우고 업로드하면 목록에서 조회되지 않게 됩니다. <br/> <br/>
          </Typography>
          <div style={{backgroundColor:theme.palette.secondary.light}}>
            <Typography variant='body2' color={theme.palette.secondary.contrastText}>
              &nbsp;&nbsp;※ 동일학생으로 학생명은 같으나, 보호자 전화번호 및 학년/반/번호 가 모두 다를 경우 동명이인으로 인식되므로, <br/>
              &nbsp;&nbsp;엑셀업로드 하기 전 보기에서 해당학생의 학년/반/번호 또는 보호자 전화번호를 엑셀자료와 같도록 <br/>
              &nbsp;&nbsp;수정해 주어야 합니다. <br/>
            </Typography> 
          </div>
          <TextField
            style={{marginTop:10}}
            variant="standard"          
            type="text"
            value={file? file.name: null}
            fullWidth
            label ="학생 목록 파일"
            InputLabelProps={{shrink: file}}
            InputProps={{
              endAdornment: (
                <IconButton component="label">
                  <AttachFileOutlinedIcon/>
                  <input
                    styles={{display:"none"}}
                    type="file"
                    accept='.xls, .xlsx, .csv' 
                    hidden
                    onChange={(e)=> {onChangeFile(e)}}
                  />
                </IconButton>
              ),
            }}
          />
        </DialogContent>
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={onUpload} disabled={file === null} variant='contained'>업로드</Button>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
		
	)
}

export default ManagerStudentPart2
